import React from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import chroma from 'chroma-js';

import { Block } from 'common/components/styleguide/grid/Block';

const StyledAlert = styled(Block)`
  border-color: ${({ theme, color }) => _.get(theme, ['colors', color], 'transparent')};
  border-radius: ${({ theme }) => _.get(theme, 'border.components.radius', _.get(theme, 'border.default.radius'))};
  ${({ theme, color }) => {
    const baseColor = chroma(_.get(theme, ['colors', color], _.get(theme, 'colors.background'))).hex();
    return `background: ${chroma(baseColor).brighten(2.3).alpha(0.2)};`;
  }}

  ${({ customStyle }) => css`
    ${customStyle}
  `}
`;

const Alert = ({
  className,
  children,
  type = 'primary',
  padding = false,
  margin = false,
  border = false,
  paddingConfig = {top: true, left: true, right: true, bottom: true},
  marginConfig = {top: false, left: false, right: false, bottom: true},
  borderConfig = {top: true, left: true, right: true, bottom: true},
  customStyle,
  flex = false,
  flexConfig = {}
}) => {
  return (
    <StyledAlert
      className={className}
      color={type}
      padding={padding}
      margin={margin}
      border={border}
      paddingConfig={paddingConfig}
      marginConfig={marginConfig}
      borderConfig={borderConfig}
      customStyle={customStyle}
      flex={flex}
      flexConfig={flexConfig}
    >
      {children}
    </StyledAlert>
  );
};

export default React.memo(Alert);
